export const REMINDER_ON_FIELD = 'reminderOnDue'
export const REMINDER_BEFORE_FIELD = 'remindersDaysBeforeDue'
export const REMINDER_AFTER_FIELD = 'remindersDaysAfterDue'

export interface InvoiceSettingsRemindersFormFields {
  [REMINDER_ON_FIELD]: boolean
  [REMINDER_BEFORE_FIELD]: number[]
  [REMINDER_AFTER_FIELD]: number[]
}
